import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { LayoutModule } from '../shared/layout/layout.module';
import { TranslateModule } from '@ngx-translate/core';
import { ExistsNumberComponent } from './exists-number.component';
import { existsNumberRoutes } from './exists-number.routes';

@NgModule({
  imports: [SharedModule, LayoutModule, RouterModule.forChild(existsNumberRoutes), TranslateModule],
  declarations: [ExistsNumberComponent],
  exports: [],
  entryComponents: [ExistsNumberComponent]
})
export class ExistsNumberModule {}
